import React from "react";
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa'
import { ButtonGroup, Container, IconButton, Stack, Text } from '@chakra-ui/react'

const Footer = () => {
  return (
    <Container as="footer" role="contentinfo" py={{ base: '10', md: '16' }}>
    <Stack spacing={{ base: '4', md: '5' }}
      marginLeft={4}
    >
      <ButtonGroup variant="ghost">
        <IconButton
          as="a"
          href="https://www.linkedin.com/in/dicky-ardiar-4460421b6/"
          aria-label="LinkedIn"
          icon={<FaLinkedin fontSize="1.25rem" />}
        />
        <IconButton as="a" href="https://github.com/Dickyrdiar" aria-label="GitHub" icon={<FaGithub fontSize="1.25rem" />} />
        {/* <IconButton
          as="a"
          href="#"
          aria-label="Twitter"
          icon={<FaTwitter fontSize="1.25rem" />}
        /> */}
      </ButtonGroup>
      <Text fontSize="sm" color="subtle">
       Created by Dicky ardiar &copy; {new Date().getFullYear()} 
      </Text>
    </Stack>
  </Container>
  )
}

export default Footer